(function(){
var CHARTS={
"O'Neill":{
hombre:[
{t:'2XS',h:[165,170],w:[52,59],nota:'Muy delgado y bajo'},
{t:'XS',h:[168,173],w:[54,64],nota:''},
{t:'S',h:[171,177],w:[62,72],nota:''},
{t:'MS',h:[168,174],w:[68,78],nota:'Más ancho que S'},
{t:'M',h:[175,181],w:[68,78],nota:'Talla más popular'},
{t:'MT',h:[181,186],w:[68,78],nota:'M alto y delgado'},
{t:'LS',h:[173,178],w:[76,86],nota:'Más ancho que M'},
{t:'L',h:[179,184],w:[76,86],nota:''},
{t:'LT',h:[184,189],w:[76,86],nota:'L alto'},
{t:'XL',h:[183,188],w:[84,97],nota:''},
{t:'XXL',h:[185,192],w:[93,109],nota:''}
],
mujer:[
{t:'2XS',h:[155,162],w:[44,51],nota:''},
{t:'XS',h:[158,165],w:[49,57],nota:''},
{t:'S',h:[163,169],w:[55,64],nota:''},
{t:'MS',h:[160,166],w:[61,70],nota:'Más ancho que S'},
{t:'M',h:[166,172],w:[61,70],nota:''},
{t:'L',h:[169,175],w:[68,79],nota:''},
{t:'XL',h:[172,178],w:[77,88],nota:''}
],
'niño':[
{t:'2',h:[87,93],w:[11,14],nota:''},
{t:'4',h:[98,107],w:[14,18],nota:''},
{t:'6',h:[110,119],w:[18,23],nota:''},
{t:'8',h:[122,130],w:[22,27],nota:''},
{t:'10',h:[132,140],w:[26,33],nota:''},
{t:'12',h:[142,150],w:[31,39],nota:''},
{t:'14',h:[150,158],w:[37,45],nota:''},
{t:'16',h:[157,165],w:[44,53],nota:''}
]
},
Manera:{
hombre:[
{t:'XS',h:[157,176],w:[54,62],nota:'Peso es prioritario'},
{t:'S',h:[162,181],w:[62,70],nota:''},
{t:'ST',h:[176,191],w:[62,70],nota:'S alto y delgado'},
{t:'MS',h:[162,175],w:[70,78],nota:'Más ancho que S'},
{t:'M',h:[170,185],w:[70,78],nota:'Talla más popular'},
{t:'MT',h:[180,195],w:[70,78],nota:'M alto y delgado'},
{t:'LS',h:[170,182],w:[78,86],nota:''},
{t:'L',h:[178,192],w:[78,86],nota:''},
{t:'LT',h:[186,198],w:[78,86],nota:'L alto'},
{t:'XL',h:[180,194],w:[86,96],nota:''},
{t:'XXL',h:[185,200],w:[96,110],nota:''}
],
mujer:[
{t:'XXS',h:[155,162],w:[42,48],nota:''},
{t:'XS',h:[158,167],w:[47,54],nota:''},
{t:'S',h:[163,172],w:[54,61],nota:''},
{t:'M',h:[168,177],w:[61,69],nota:''},
{t:'L',h:[173,182],w:[69,76],nota:''},
{t:'XL',h:[178,187],w:[76,82],nota:''}
]
},
Buell:{
hombre:[
{t:'XS',h:[165,170],w:[55,65],nota:''},
{t:'S',h:[168,175],w:[63,73],nota:''},
{t:'MS',h:[165,172],w:[70,80],nota:''},
{t:'M',h:[173,179],w:[70,80],nota:''},
{t:'MT',h:[179,185],w:[70,80],nota:'M alto'},
{t:'L',h:[176,182],w:[79,89],nota:''},
{t:'LT',h:[182,188],w:[79,89],nota:'L alto'},
{t:'XL',h:[180,186],w:[88,100],nota:''},
{t:'XXL',h:[184,190],w:[98,113],nota:''}
],
mujer:[
{t:'2',h:[155,160],w:[45,52],nota:''},
{t:'4',h:[158,165],w:[50,59],nota:''},
{t:'6',h:[162,170],w:[57,66],nota:''},
{t:'8',h:[166,174],w:[63,73],nota:''},
{t:'10',h:[170,178],w:[70,80],nota:''},
{t:'12',h:[174,182],w:[77,87],nota:''}
]
},
Patagonia:{
hombre:[
{t:'XS',h:[168,173],w:[54,64],nota:''},
{t:'S',h:[173,178],w:[61,70],nota:''},
{t:'MS',h:[171,174],w:[64,73],nota:''},
{t:'M',h:[176,180],w:[68,77],nota:''},
{t:'MT',h:[181,186],w:[68,77],nota:'M alto'},
{t:'L',h:[179,183],w:[77,86],nota:''},
{t:'LT',h:[184,189],w:[77,86],nota:'L alto'},
{t:'XL',h:[182,186],w:[84,95],nota:''},
{t:'XXL',h:[185,190],w:[93,107],nota:''}
],
mujer:[
{t:'XS',h:[158,165],w:[48,56],nota:''},
{t:'S',h:[163,170],w:[55,64],nota:''},
{t:'M',h:[168,175],w:[62,71],nota:''},
{t:'L',h:[173,180],w:[69,79],nota:''},
{t:'XL',h:[177,184],w:[77,88],nota:''}
]
}
};
var GENERIC={
hombre:[
{t:'XS',h:[162,168],w:[52,62],nota:''},
{t:'S',h:[167,174],w:[60,70],nota:''},
{t:'M',h:[172,180],w:[68,78],nota:'Talla más común'},
{t:'L',h:[178,185],w:[76,87],nota:''},
{t:'XL',h:[183,190],w:[84,98],nota:''}
],
mujer:[
{t:'XS',h:[155,162],w:[44,52],nota:''},
{t:'S',h:[160,168],w:[50,59],nota:''},
{t:'M',h:[165,173],w:[57,67],nota:''},
{t:'L',h:[170,178],w:[65,75],nota:''},
{t:'XL',h:[175,183],w:[73,83],nota:''}
],
'niño':[
{t:'8',h:[122,132],w:[22,28],nota:''},
{t:'10',h:[130,142],w:[26,33],nota:''},
{t:'12',h:[140,152],w:[30,40],nota:''},
{t:'14',h:[150,162],w:[37,47],nota:''}
]
};
var BRAND_NOTES={
"O'Neill":"O'Neill usa tallas intermedias(MS,MT,LS,LT). MS=más ancho que S,MT=M alto y delgado. Prioriza el pecho sobre la altura.",
Manera:'Manera prioriza el peso sobre la altura. ST=S alto y delgado,MS=M corto y ancho,MT=M alto y delgado. El neopreno Manera es más ajustado — cede con el uso.',
Buell:'Buell tiene talla verdadera(true-to-size). Mujer usa numeración 2/4/6/8/10/12. Si estás entre dos tallas,Buell recomienda la más grande.',
Patagonia:'Patagonia corre levemente pequeña — si estás al límite superior sube de talla. El caucho Yulex es más rígido que el neopreno convencional al inicio.',
Sirena:'Tabla orientativa para Sirena. Para ajuste exacto,consulta con el equipo de El Ruco.',
'Salty Skin':'Tabla orientativa para Salty Skin. Para ajuste exacto,consulta con el equipo de El Ruco.'
};
function getChart(vendor,gender){
var base=CHARTS[vendor] || GENERIC;
var g=(gender || '').toLowerCase();
if(g.indexOf('mujer')> -1 || g.indexOf('women')> -1 || g.indexOf('female')> -1){
return base.mujer || GENERIC.mujer;
}
if(g.indexOf('niño')> -1 || g.indexOf('kid')> -1 || g.indexOf('youth')> -1 || g.indexOf('grom')> -1){
return base['niño'] || GENERIC['niño'];
}
return base.hombre || GENERIC.hombre;
}
function findTalla(vendor,gender,h,w){
var chart=getChart(vendor,gender);
var i;
for(i=0;i < chart.length;i++){
var row=chart[i];
var hOk=!h ||(h >=row.h[0] && h <=row.h[1]);
var wOk=!w ||(w >=row.w[0] && w <=row.w[1]);
if(hOk && wOk)return{talla:row.t,nota:row.nota,match:'exact'};
}
if(w){
for(i=0;i < chart.length;i++){
if(w >=chart[i].w[0] && w <=chart[i].w[1]){
return{talla:chart[i].t,nota:'Basado en tu peso. Verifica con la altura.',match:'weight'};
}
}
}
return null;
}
function initBlock(config){
var vendor=config.vendor;
var gender=config.gender;
var pid=config.productId;
function renderTable(){
var chart=getChart(vendor,gender);
var table=document.getElementById('traje-tabla-' + pid);
if(!table)return;
var thead='<thead><tr><th>Talla</th><th>Altura(cm)</th><th>Peso(kg)</th></tr></thead>';
var tbody='<tbody>';
chart.forEach(function(row){
tbody +='<tr><td class="ruco-dims__medida">' + row.t + '</td>';
tbody +='<td>' + row.h[0] + '–' + row.h[1] + ' cm</td>';
tbody +='<td>' + row.w[0] + '–' + row.w[1] + ' kg</td></tr>';
});
tbody +='</tbody>';
table.innerHTML=thead + tbody;
var noteEl=document.getElementById('traje-brand-note-' + pid);
if(noteEl){
noteEl.textContent=BRAND_NOTES[vendor] || 'Las tallas de neopreno no corresponden a la ropa. Si estás entre dos tallas,elige la más grande.';
}
}
function calc(){
var hEl=document.getElementById('traje-altura-' + pid);
var wEl=document.getElementById('traje-peso-' + pid);
var resEl=document.getElementById('traje-result-' + pid);
var tallaEl=document.getElementById('traje-talla-' + pid);
var notaEl=document.getElementById('traje-nota-' + pid);
if(!hEl || !wEl || !resEl)return;
var h=parseFloat(hEl.value)|| null;
var w=parseFloat(wEl.value)|| null;
if(!h && !w){
resEl.style.display='none';
return;
}
var result=findTalla(vendor,gender,h,w);
var table=document.getElementById('traje-tabla-' + pid);
if(result){
tallaEl.textContent=result.talla;
var notaTxt=result.nota ||('Tu talla recomendada para ' + vendor + '.');
if(result.match==='exact'){
notaTxt='Talla exacta para tu altura y peso en ' + vendor + '. ' + result.nota;
}
notaEl.textContent=notaTxt;
resEl.style.display='block';
if(table){
Array.from(table.querySelectorAll('tr')).forEach(function(tr){
var first=tr.querySelector('.ruco-dims__medida');
if(first){
tr.className=first.textContent.trim()===result.talla ? 'ruco-dims__row--active':'';
}
});
}
}else{
tallaEl.textContent='?';
notaEl.textContent='No encontramos una talla exacta. Consulta con nosotros para asesorarte.';
resEl.style.display='block';
}
}
renderTable();
var hEl=document.getElementById('traje-altura-' + pid);
var wEl=document.getElementById('traje-peso-' + pid);
if(hEl)hEl.addEventListener('input',calc);
if(wEl)wEl.addEventListener('input',calc);
}
function boot(){
document.querySelectorAll('script[type="application/json"][id^="ruco-traje-data-"]').forEach(function(node){
try{
var config=JSON.parse(node.textContent);
if(config && config.productId)initBlock(config);
}catch(e){}
});
}
if(document.readyState==='loading'){
document.addEventListener('DOMContentLoaded',boot);
}else{
boot();
}
})();